<template>
  <div class="task-tag-page">
    <div class="search">
      <div class="left">
        <el-form
          :inline="true"
          class="query-form"
          @submit.native.prevent
        >
          <el-row
            :gutter="20"
            class="query-row"
          >
            <el-col
              :span="queryKeywordSpan"
              class="query-item"
            >
              <el-form-item>
                <el-input
                  v-model.trim="search.keyword"
                  placeholder="请输入任务名称、聚合名称、产品名称"
                  clearable
                  style="width: 100%"
                  @keyup.enter.native="handleSearch"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="queryActionSpan"
              class="query-item query-item--actions"
            >
              <div class="query-buttons">
                <el-button
                  plain
                  type="primary"
                  @click="handleReset"
                >
                  重置
                </el-button>
                <el-button
                  type="primary"
                  @click="handleSearch"
                >
                  查询
                </el-button>
                <!-- <el-button
                  v-if="showQueryToggle"
                  type="text"
                  class="query-toggle"
                  @click="toggleQueryExpand"
                >
                  {{ queryExpanded ? '收起' : '展开' }}
                  <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                </el-button> -->
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <!-- <div style="display: flex; justify-content: flex-end;">
      
    </div> -->

    <div class="data">
      <div class="table-header-actions">
        <el-button
          type="primary"
          @click="handleDialogOpen"
        >
          新建
        </el-button>
      </div>
      <el-table
        :data="list"
        border
      >
        <el-table-column
          v-for="(c, i) in column"
          :key="i"
          :label="c.label"
          :prop="c.prop"
        >
          <div slot-scope="scope">
            <template v-if="c.prop === 'budgets'">
              <el-tag
                v-for="v in (scope.row.budgets)"
                :key="v.product_id"
                type="success"
                size="small"
                style="margin-left: 8px;"
              >
                {{ v.name || '-' }}
              </el-tag>
            </template>
            <template v-else-if="c.prop === 'products'">
              <el-tag
                v-for="v in (scope.row.products)"
                :key="v.product_id"
                type="success"
                size="small"
                style="margin-left: 8px;"
              >
                {{ v.name || '-' }}
              </el-tag>
            </template>
            <template v-else-if="c.prop === 'opt'">
              <el-button
                type="text"
                @click="handleEditAggregaton(scope.row)"
              >
                修改聚合
              </el-button>
              <el-button
                type="text"
                @click="handleEditProduct(scope.row)"
              >
                修改产品
              </el-button>
              <!-- <el-popconfirm
                :title="`确认删除${scope.row.name || 'adwd'}？`"
                @confirm="handleDelete(scope.row)"
              >
                <el-button 
                  type="text" 
                  style="color: #f56c6c; margin-left: 8px" 
                  slot="reference"
                >删除</el-button>
              </el-popconfirm> -->
            </template>
            <template v-else>
              {{ scope.row[c.prop] || '--' }}
            </template>
          </div>
        </el-table-column>
      </el-table>

      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="handleChangePage"
        />
      </div>
    </div>

    <!-- 新建 -->
    <el-dialog
      :visible.sync="detailVisible"
      title="添加任务"
      width="600px"
      class="dialog"
    >
      <el-form label-width="120px">
        <el-form-item label="任务名称">
          <el-input
            v-model="form.name"
            placeholder="请输入任务名称"
            class="input"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="detailVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="handleDialogConfirm"
        >
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 修改聚合 -->
    <form-dialog
      :visible.sync="aggregationVisible"
      title="修改聚合"
      width="500px"
      @submit="handleAggregationDialogConfirm"
    >
      <el-form label-width="100px">
        <el-form-item label="已选择聚合">
          <div v-if="form2.budgets && form2.budgets.length">
            <el-tag
              v-for="(v, index) in form2.budgets"
              :key="v.id"
              size="small"
              closable
              style="margin-left: 8px;"
              @close="handleCloseAggregation(v, index)"
            >
              {{ v.name || '' }}
            </el-tag>
          </div>
          <div v-else>--</div>
        </el-form-item>

        <el-form-item
          label="选择聚合"
          prop="budget_name"
        >
          <el-select
            v-model="form2.selectBudgets"
            filterable
            clearable
            remote
            :remote-method="_searchSalors"
            placeholder="请选择聚合预算"
            :loading="editProdSalorDlg.searchLoading"
            style="width: 91%"
            multiple
            @change="onBudgetChange"
          >
            <el-option
              v-for="item in editProdSalorDlg.options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </form-dialog>

    <!-- 修改产品 -->
    <form-dialog
      :visible.sync="productVisible"
      title="修改产品"
      width="600px"
      @submit="handleProductDialogConfirm"
    >
      <el-form label-width="100px">
        <el-form-item label="已选择产品">
          <div v-if="form3.products.length">
            <el-tag
              v-for="v in form3.products"
              :key="v.id"
              size="small"
              closable=""
              style="margin-left: 8px;"
              @close="handleCloseProduct(v, index)"
            >
              {{ v.name || '' }}
            </el-tag>
          </div>
          <div v-else>--</div>
        </el-form-item>
        <el-form-item label="选择产品">
          <el-select
            v-model="form3.selectProducts"
            multiple
            filterable
            remote
            :remote-method="_searchProduct"
            :loading="editProdProductDlg.searchLoading"
            placeholder="请选择合作产品"
            style="width: 100%"
            @change="onProductChange"
          >
            <el-option
              v-for="item in editProdProductDlg.prodOps"
              :key="item.product_id"
              :label="item.product_name"
              :value="item.product_id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </form-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import FormDialog from '@/components/FormDialog';

const req = new Request();
const STATUS_OPTIONS = [
  { name: '有效', value: 1 },
  { name: '失效', value: 0 },
];
const createDefaultSearch = () => ({
  keyword: '',
});

export default {
  name: 'product-series',
  components: {
    FormDialog,
  },
  data() {
    return {
      optionStatusList: STATUS_OPTIONS,
      queryExpanded: true,
      search: createDefaultSearch(),
      column: [
        { label: '任务编号', prop: 'id' },
        { label: '任务标签名称', prop: 'name' },
        { label: '聚合名称', prop: 'budgets' },
        { label: '产品名称', prop: 'products' },
        { label: '操作', prop: 'opt' },
      ],
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      detailVisible: false,
      aggregationVisible: false,
      productVisible: false,
      form: {
        id: '',
        name: '',
      },
      form2: {
        loading: false,
        id: '',
        budgets: [],
        selectBudgets: [],
      },
      form3: {
        id: '',
        products: [],
        selectProducts: [],
      },
      editProdSalorDlg: {
        searchLoading: false,
        options: [],
        form: {
          customer_id: '',
          product_id: '',
        },
      },
      editProdProductDlg: {
        visible: false,
        loading: false,
        searchLoading: false,
        // prods: [],
        prodOps: [],
        // initSelectedProds: [],
        // selectedProd: [],
      },
    };
  },

  computed: {
    showQueryToggle() {
      return true;
    },
    queryKeywordSpan() {
      return 12;
    },
    queryActionSpan() {
      return 12
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    async _searchProduct(key) {
      if (!key) return [];
      try {
        this.editProdProductDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.taskTag.productDetail, { keyword: key })
          .fin(() => {
            this.editProdProductDlg.searchLoading = false;
          });
        const prods = (res.data || []).map((i) => ({
          product_id: i.id,
          product_name: i.name,
        }));
        this.editProdProductDlg.prodOps = [
          ...new Set([...prods].map((i) => JSON.stringify(i))),
        ].map((i) => JSON.parse(i));
        // this.editProdProductDlg.prodOps = [
        //   ...new Set(
        //     [...this.editProdProductDlg.prodOps, ...prods].map((i) =>
        //       JSON.stringify(i),
        //     ),
        //   ),
        // ].map((i) => JSON.parse(i));
      } catch (err) {
        this.$message.error(`获取产品列表失败：${err.message || '未知错误'}`);
      }
    },
    // 输入并选择聚合预算下拉框
    async _searchSalors(key) {
      if (!key) return [];
      try {
        this.editProdSalorDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.taskTag.budgetDetail, {
            keyword: key,
            status: 1,
          })
          .fin(() => {
            this.editProdSalorDlg.searchLoading = false;
          });
        this.editProdSalorDlg.options = res.data || [];
      } catch (err) {
        this.$message.error(`获取聚合预算失败：${err.message || '未知错误'}`);
      }
    },
    handleCloseAggregation(budgets, index) {
      this.form2.budgets.splice(index, 1);
    },
    handleCloseProduct(products, index) {
      this.form3.products.splice(index, 1);
    },
    // 聚合预算与销售名称实现联动
    onBudgetChange(value) {
      this.form2.selectBudgets = value;
    },
    onProductChange(value) {
      this.form3.selectProducts = value;
    },
    init() {
      this.getList();
    },
    // 搜索
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    handleReset() {
      this.search = createDefaultSearch();
      this.page = 1;
      this.getList();
    },
    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },
    async getList() {
      try {
        const { data } = await req.send(req.Apis.customer.taskTag.list, {
          keyword: this.search.keyword,
          page: this.page,
          page_size: this.pageSize,
        });
        this.list = data.list || [];
        this.total = Number(data.total);
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },
    handleChangePage(n) {
      this.page = n;
      this.getList();
    },
    handleEditAggregaton(row) {
      this.form2 = {
        id: parseInt(row.id, 10),
        budgets: row.budgets,
      };
      this.aggregationVisible = true;
    },
    handleEditProduct(row) {
      this.form3 = {
        id: parseInt(row.id, 10),
        products: row.products,
      };
      this.productVisible = true;
    },
    async handleDelete(row) {
      let params = {
        id: parseInt(row.id, 10),
      };
      let api = req.Apis.customer.taskTag.delete;
      try {
        await req.send(api, params);
        this.$message.success('操作成功');
        this.getList();
      } catch (err) {}
    },
    // dialog: open
    handleDialogOpen() {
      this.detailVisible = true;
      this.form = {
        id: '',
        name: '',
      };
    },
    async handleDialogConfirm() {
      let params = {
        name: this.form.name,
      };
      let api = req.Apis.customer.taskTag.add;

      if (!this.form.name) {
        this.$message.error('请输入产品系名称');
        return;
      }
      // 编辑
      if (this.form.id) {
        params['id'] = this.form.id;
        api = req.Apis.customer.taskTag.update;
      }

      try {
        await req.send(api, params);
        this.$message.success('操作成功');
        this.getList();
      } catch (err) {}
      this.detailVisible = false;
    },
    async handleAggregationDialogConfirm() {
      const _ids = (this.form2.budgets || []).map((item) => item.budget_id);
      let params = {
        id: this.form2.id,
        budget_ids: [...(_ids || []), ...(this.form2.selectBudgets || [])],
      };
      let api = req.Apis.customer.taskTag.updateAggregation;

      try {
        await req.send(api, params);
        this.$message.success('操作成功');
        this.getList();
      } catch (err) {}
      this.aggregationVisible = false;
    },
    async handleProductDialogConfirm() {
      const _ids = (this.form3.products || []).map((item) => item.product_id);
      let params = {
        id: this.form3.id,
        product_ids: [...(_ids || []), ...(this.form3.selectProducts || [])],
      };
      let api = req.Apis.customer.taskTag.updateProduct;

      try {
        await req.send(api, params);
        this.$message.success('操作成功');
        this.getList();
      } catch (err) {}
      this.productVisible = false;
    },
  },
};
</script>

<style lang="less">
.table-header-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 10px;
}
.task-tag-page {
  .search {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  }

  .left {
    flex: 1;
  }

  .right {
    flex-shrink: 0;
  }

  .query-form {
    width: 100%;
  }

  .query-item {
    margin-bottom: 12px;
  }

  .query-item--actions {
    display: flex;
    align-items: flex-start;
  }

  .query-buttons {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
  }

  .query-toggle {
    padding: 0;
  }

  .data {
    margin-top: 20px;

    .page {
      margin-top: 20px;
      text-align: right;
    }
  }

  .dialog {
    .input {
      width: 400px;
    }
  }
}

.task-tag-page .query-form .el-form-item {
  display: block;
  width: 100%;
  margin-right: 0;
  margin-bottom: 0;
}

.task-tag-page .query-form .el-form-item__content {
  width: 100%;
}

.task-tag-page .query-buttons .el-button + .el-button {
  margin-left: 0;
}
</style>
